import * as z from "zod";
import { isoDate } from "./common";

/** A calendar app's subscription to the card shows in some US states. The id is the feed's secret. */
export const ShowCalendarSubscription = z.object({
  id: z.string(),
  /** US state codes, each once. */
  states: z.array(z.string()),
  /** The iCalendar feed: `https://` as given, `webcal://` in its place to open a calendar app's subscribe flow. */
  feedUrl: z.string(),
  /** When it was revoked: the feed answers empty from then on. */
  revokedAt: isoDate.nullable(),
  createdAt: isoDate,
  updatedAt: isoDate,
});
export type ShowCalendarSubscription = z.output<typeof ShowCalendarSubscription>;
